import type { WrittenPage } from '../../sections'
import { LINKS } from '../links'

/**
 * Kağan Şahin'in iletişim sayfası — İngilizcesinin Türkçesi.
 *
 * 15.09.2026'da adresiyle birlikte istendi; bilgiler verildiği gibi duruyor:
 * isim, unvan, iki telefon ve mail adresi. Bölüm sırası İngilizcesiyle aynı,
 * yalnızca söyleyiş Türkçe.
 *
 * 15.09.2026'da ekip iletişim sayfalarının birbiriyle bütünlüklü olması istendi:
 * unvan eyebrow'da, adın altında tek satır rol, kartın başlığının doğrudan
 * adres ya da numara olduğu bir `features` grid'i ve sonda hep aynı iletişim
 * bandı. Rol paragrafı bu yüzden `sub`a taşındı ve kartlara `href` geldi.
 */
const EMAIL = 'kagan@digitopia.ai'
const LINKEDIN = 'https://www.linkedin.com/in/kagansahin/'

export const teamKaganSahin: WrittenPage = {
  navLabel: 'Kağan Şahin',
  title: 'Kağan Şahin: Eş-CEO, Operasyon',
  description:
    'Digitopia Eş-CEO’su Kağan Şahin’e ulaşın: kagan@digitopia.ai, +1 302 607 4600 (ABD) veya +32 460 94 98 70 (Belçika).',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'Eş-CEO, Operasyon',
      headline: 'Kağan Şahin',
      align: 'center',
      // 15.09.2026: fotoğraf yok — sayfaya zaten yüzünün olduğu bir kartvizitten
      // QR okutarak geliniyor, burası bir profil değil iletişim bilgisi.
      ctas: [
        { label: 'E-posta', href: `mailto:${EMAIL}` },
        { label: 'LinkedIn', href: LINKEDIN },
        // 17.09.2026: telefona doğrudan kaydetmek için vCard. Dosya
        // `public/vcf/` içinde, sayfanın slug'ıyla aynı adda.
        { label: 'Rehbere kaydet', href: '/vcf/kagan-sahin.vcf' },
      ],
    },
    {
      kind: 'features',
      heading: 'İletişim',
      columns: 3,
      items: [
        {
          title: EMAIL,
          note: 'E-posta',
          href: `mailto:${EMAIL}`,
        },
        {
          title: '+1 302 607 4600',
          note: 'ABD',
          href: 'tel:+13026074600',
        },
        {
          title: '+32 460 94 98 70',
          note: 'Belçika',
          href: 'tel:+32460949870',
        },
      ],
      footnote: 'Digitopia New York, Londra ve İstanbul’dan çalışıyor.',
    },
    {
      kind: 'cta',
      heading: 'Kişi yerine firmayla mı başlamak istersiniz?',
      sub: 'İletişim formu tüm ekibe ulaşır; Hakkımızda ise birlikte çalışacağınız diğer isimleri anlatır.',
      tone: 'band',
      ctas: [
        { label: 'Digitopia ile iletişime geçin', href: LINKS.contact },
        { label: 'Hakkımızda', href: LINKS.about },
      ],
    },
  ],
}
